/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum MatStatusIndicatorState {
	NotStarted = 'NotStarted',
	InProgress = 'InProgress',
	Success = 'Success',
	Failure = 'Failure',
}
